/**
 * Compares two arrays of tags to determine if they are equivalent.
 */
export function handleCheckIfTagsAreEqual(currentTags: string[], initialTags: string[]): boolean {
  if (currentTags?.length !== initialTags?.length) {
    return false;
  }

  const currentTagsSet = new Set(currentTags);
  const initialTagsSet = new Set(initialTags);

  // Note: Using .every() instead of .isSubsetOf() for browser compatibility
  return currentTagsSet.size === initialTagsSet.size && [...currentTagsSet].every((tag: string) => initialTagsSet.has(tag));
}
